module.exports = __webpack_public_path__ + "static/media/pg-taxas.04b686fb.png";